// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wm0s","col":"styles_col__2OI62"};